import React, { useContext } from 'react';

import styled from '@emotion/styled';

import {
  KycDirectorOneDataType,
  kycDirectorOneInitialValues,
  KycDirectorOneSchema,
} from '../../../../models/dashboard/configuration/kycDirectorOne';
import { kycInformationActions } from '../../../../redux/slices/kycInformationSlice';
import { useAppDisPatch } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import SingleDocumentUploadField from '../../../FormCom/SingleDocumentUploadField';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';

const directorOneIdentificationTypeOptions: Record<string, string> = {
  'National Identification Number (NIN)': 'NIN',
  'International Passport': 'Passport',
  'Drivers License': 'DriversLicense',
};

const DirectorOneKycForm = () => {
  const dispatch = useAppDisPatch();
  const { setSliderIndexPos } = useContext(TranslatingContainerContext)!;

  const onSubmit = (value: KycDirectorOneDataType) => {
    const { directorOneName, directorOneIdentificationType, directorOneId } =
      value;

    const validIdentificationDocument = (directorOneId ?? []).filter(
      (file): file is File => file instanceof File,
    );

    if (validIdentificationDocument.length > 0) {
      dispatch(
        kycInformationActions.setKycDirectorOneSlider({
          directorOneName,
          directorOneIdentificationType:
            directorOneIdentificationTypeOptions[directorOneIdentificationType],
          directorOneId: validIdentificationDocument,
        }),
      );
    }
    setSliderIndexPos(1);
  };

  return (
    <Container>
      <FormComponent
        initialValues={kycDirectorOneInitialValues}
        schema={KycDirectorOneSchema}
        onSubmit={onSubmit}
        className={'small-gap'}
      >
        <TextInputField
          label='Name of Director 1'
          name='directorOneName'
          id='directorOneName'
          type='text'
          placeholder='Input your full name'
        />

        <CustomSelectField
          label='Identification'
          name='directorOneIdentificationType'
          id='directorOneIdentificationType'
          placeholder='Select ID type...'
          optionData={Object.keys(directorOneIdentificationTypeOptions)}
        />

        <SingleDocumentUploadField
          id='directorOneId'
          name='directorOneId'
          label='Upload ID of Director 1'
          placeholder='Drag your file to start uploading'
        />

        <FormSubmitButton className='blue topMargin large'>
          Continue
        </FormSubmitButton>
      </FormComponent>
    </Container>
  );
};

export default DirectorOneKycForm;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;
